import { render, staticRenderFns } from "./add-acknowledgement.vue?vue&type=template&id=23cf3295"
import script from "./add-acknowledgement.vue?vue&type=script&lang=js"
export * from "./add-acknowledgement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports